export enum CoOpActionKeys {
  DELETE_COOP_CAMPAIGN_TYPE = 'DELETE_COOP_CAMPAIGN_TYPE',
  FETCH_COOP_DEALER_ESTIMATES = 'FETCH_COOP_DEALER_ESTIMATES',
  FETCH_COOP_DEALER_REQUESTS = 'FETCH_COOP_DEALER_REQUESTS',
  FETCH_COOP_GLOBAL_SETTINGS = 'FETCH_COOP_GLOBAL_SETTINGS',
  FETCH_COOP_REGION_BUDGETS = 'FETCH_COOP_REGION_BUDGETS',
  FETCH_COOP_REQUEST = 'FETCH_COOP_REQUEST',
  FETCH_COOP_REQUEST_STATUSES = 'FETCH_COOP_REQUEST_STATUSES',
  FETCH_COOP_REQUESTS = 'FETCH_COOP_REQUESTS',
  FETCH_COOP_SALESDISTRICT_BUDGETS = 'FETCH_COOP_SALESDISTRICT_BUDGETS',
  SET_COOP_ACTIVE_STATUS = 'SET_COOP_ACTIVE_STATUS',
  SET_COOP_DEALER_ESTIMATES = 'SET_COOP_DEALER_ESTIMATES',
  SET_COOP_GLOBAL_SETTINGS = 'SET_COOP_GLOBAL_SETTINGS',
  SET_COOP_REGION_BUDGETS = 'SET_COOP_REGION_BUDGETS',
  SET_COOP_REQUEST_STATUSES = 'SET_COOP_REQUEST_STATUSES',
  SET_COOP_REQUESTS = 'SET_COOP_REQUESTS',
  SET_COOP_SALESDISTRICT_BUDGETS = 'SET_COOP_SALESDISTRICT_BUDGETS',
  UPDATE_COOP_CAMPAIGN_TYPE = 'UPDATE_COOP_CAMPAIGN_TYPE',
  UPDATE_COOP_DEALER_ESTIMATE = 'UPDATE_COOP_DEALER_ESTIMATE',
  UPDATE_COOP_GLOBAL_SETTINGS = 'UPDATE_COOP_GLOBAL_SETTINGS',
  UPDATE_COOP_REGION_BUDGETS = 'UPDATE_COOP_REGION_BUDGETS',
  UPDATE_COOP_REQUEST = 'UPDATE_COOP_REQUEST',
  UPDATE_COOP_SALESDISTRICT_BUDGETS = 'UPDATE_COOP_SALESDISTRICT_BUDGETS',
  UPDATE_COOP_STATE = 'UPDATE_COOP_STATE',
  UPDATE_COOP_STATUS = 'UPDATE_COOP_STATUS'
}
